module.exports = __webpack_public_path__ + "img/logo_xpress_money.eb8db7c1.png";